import * as THREE from 'three';
//import { OrbitControls } from 'three/addons/controls/OrbitControls.js'; //html时用,因为html已经定义了
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import modelGltf from './modelGltf.js';//stl模型对象

let currentSpin = 'modelFont';//当前旋转的状态

let currentMenuButton = null;//当前的菜单按钮
let contrastMenuStatu = false;//菜单-> 对比状态
let occlusMenuStatu = false;//菜单-> 咬合状态
let dbJawMenuStatu = false;//菜单-> 颌面观状态

let upToothStatu = false;//上颌状态
let lowerToothStatu = false;//下颌状态
//场景
const scene = new THREE.Scene();
scene.background = new THREE.Color(0xffffff);

scene.add(modelGltf); //模型对象添加到场景中

//光源设置-平行光
const dirLight = new THREE.DirectionalLight(0xffffff, 0.326);
scene.add(dirLight);

//环境光
const ambientlight = new THREE.AmbientLight(0xffffff, 0.7);
scene.add(ambientlight);


//相机
// 200表示左侧div元素宽度195px+间距5px
const width = window.innerWidth - 17; //canvas画布宽度
//60表示顶部div元素高度55px+间距5px
const height = window.innerHeight - 170; //canvas画布高度
const camera = new THREE.PerspectiveCamera(50, width / height, 1, 3000);
camera.position.set(80, 30, 80);
dirLight.position.set(90, 0, 90);//平行光跟随相机照射
camera.lookAt(0, 0, 0);


// WebGL渲染器设置
const renderer = new THREE.WebGLRenderer({
    antialias: true, //开启优化锯齿
    powerPreference: "high-performance",
    physicallyCorrectLights: true
});
renderer.setPixelRatio(window.devicePixelRatio); //防止输出模糊
renderer.setSize(width, height);

//如果是html静态页，需要获取元素赋值
//document.getElementById('webgl').appendChild(renderer.domElement);
//renderer.setClearColor(0xd3cccc);


// 渲染循环
render();
function render() {
    //console.log('camera.position',camera.position);
    renderer.render(scene, camera);
    requestAnimationFrame(render);
}


//轨道控制器 鼠标拖动、放大等功能
const controls = new OrbitControls(camera, renderer.domElement);
controls.addEventListener('change', function () {
    console.log('camera.position', camera.position);
    // console.log('camera.position', camera.position.x);
    // console.log('获取对象：', modelStl);
    // 设置直射光跟随相机照射
    dirLight.position.set(camera.position.x - 20, 0, camera.position.z - 20);
    //console.log('上牙模型角度属性.rotation的值', modelGltf.children[0].rotation);
});

// 画布跟随窗口变化
window.onresize = function () {
    const width = window.innerWidth - 20; //canvas画布宽度
    const height = window.innerHeight - 60; //canvas画布高度
    renderer.setSize(width, height);
    camera.aspect = width / height;
    camera.updateProjectionMatrix();
};

//======================页头中菜单事件=================
//初始化菜单最初状态，这样操作菜单按钮从而保持当前状态
function initMenu(operatMenu,currentMenuButton){
    if("attachButton" == operatMenu){
        switch(currentMenuButton) {
            case 'contrastButton':
                    contrastLoseFocus();
                break;
            case 'occlusionButton':
                    occlusLoseFocus();
                break;    
            case 'dbJawButton':
                    dbJawLoseFocus();
                break;                
        }
    }else if("contrastButton" == operatMenu){
        switch(currentMenuButton) {
            case 'attachButton':
                    attachLoseFocus();
                break;
            case 'occlusionButton':
                    occlusLoseFocus();
                break;    
            case 'dbJawButton':
                    dbJawLoseFocus();
                break;
                
        }
    }else if("occlusionButton" == operatMenu){
        switch(currentMenuButton) {
            case 'attachButton':
                    attachLoseFocus();
                break;
            case 'contrastButton':
                    contrastLoseFocus();
                break;    
            case 'dbJawButton':
                    dbJawLoseFocus();
                break;                
        }
    }else if("dbJawButton" == operatMenu){
        switch(currentMenuButton) {
            case 'attachButton':
                    attachLoseFocus();
                break;
            case 'contrastButton':
                    contrastLoseFocus();
                break;    
            case 'occlusionButton':
                    occlusLoseFocus();
                break;                
        }
    }    
};

//附件
const attachmentsMenu = ()=>{     
    initMenu("attachButton",currentMenuButton);
    attachGotFocus();
    updateMenuStyle("attachButton");
    currentMenuButton = "attachButton";
};

function attachGotFocus(){
    //获取属性焦点,附件可见
    if(modelGltf.children[0].visible){
        //modelGltf.children[2].visible = true;
    }
    if(modelGltf.children[1].visible){
        //modelGltf.children[3].visible = true;  
    }
};

//对比
const contrastMenu = ()=>{
    initMenu("contrastButton",currentMenuButton);
    if (!contrastMenuStatu) {
        contrastGotFocus();
    } else {
        contrastLoseFocus();
    }
    updateMenuStyle("contrastButton");
    currentMenuButton = "contrastButton";
};
function contrastGotFocus(){
    //获取对比焦点
    var upToothsGlbModelArr = modelGltf.children[0].children[0].children;
    var downToothsGlbModelArr = modelGltf.children[1].children[0].children;
    upToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.color.set(0xababab);
            val.material.opacity = 0.97;//透明度
        }
    });

    downToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.color.set(0xababab);
            val.material.opacity = 0.97;//透明度
        }
    });
    contrastMenuStatu = true;
};
function contrastLoseFocus(){
    //失去对比焦点
    var upToothsGlbModelArr = modelGltf.children[0].children[0].children;
    var downToothsGlbModelArr = modelGltf.children[1].children[0].children;
    upToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.color.set(0xf2efe5);
            val.material.opacity = 1;//透明度
        }
    });
    downToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.color.set(0xf2efe5);
            val.material.opacity = 1;//透明度
        }
    });
    contrastMenuStatu = false;          
};

//咬合
const occlusMenu = ()=>{ 
    initMenu("occlusionButton",currentMenuButton);
    if (!occlusMenuStatu) {
        occlusGotFocus();
    } else {
        occlusLoseFocus();
    }
    updateMenuStyle("occlusionButton");
    currentMenuButton = "occlusionButton";
};
function occlusGotFocus(){
    //获取咬合焦点
    var upToothsGlbModelArr = modelGltf.children[0].children[0].children;
    var downToothsGlbModelArr = modelGltf.children[1].children[0].children;
    upToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.opacity = 0.5;//透明度 
        }
    });
    downToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.opacity = 0.5;//透明度 
        }
    });
    occlusMenuStatu = true;
};
function occlusLoseFocus(){
    //失去咬合焦点 
    var upToothsGlbModelArr = modelGltf.children[0].children[0].children;
    var downToothsGlbModelArr = modelGltf.children[1].children[0].children;
    upToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.opacity = 1;//透明度 
        }
    });
    downToothsGlbModelArr.forEach(function (val) {
        if (val.name != "gum") {
            val.material.opacity = 1;//透明度
        }
    });
    occlusMenuStatu = false;         
};

//颌面观
const dbJawMenu = ()=>{      
    if (!dbJawMenuStatu) {
        // console.log('===原始模型角度属性.rotation的值', modelGltf.children[0].rotation);
        dbJawGotFocus();
    } else {
        dbJawLoseFocus();
    }
    initMenu("dbJawButton",currentMenuButton);
    updateMenuStyle("dbJawButton");
    currentMenuButton = "dbJawButton";
};
function dbJawGotFocus(){
    //先旋转到正面    
    spinToothClick("modelFont"); 
    //隐藏掉视图按钮
    var viewBox = document.getElementById("angleBox");
    viewBox.style.display = 'none';  

    //获取颌面观焦点
    modelGltf.children[0].position.set(-80, 2, 10);
    modelGltf.children[0].rotateX(-0.9);
    modelGltf.children[0].rotateY(-0.19);
    modelGltf.children[0].rotateZ(1.19);

    modelGltf.children[1].position.set(0, 2, -50);
    modelGltf.children[1].rotateX(0.79);
    modelGltf.children[1].rotateY(-0.4);
    modelGltf.children[1].rotateZ(-0.69);
    dbJawMenuStatu = true;
};
function dbJawLoseFocus(){
    //判断视图正面是否获取焦点，不是重置焦点
    let odiv= document.getElementById("frontLi");
    if(!odiv.classList.contains('angleTrue')){
        updateViewStyle("frontLi");
    }

    //显示视图按钮
    var viewBox = document.getElementById("angleBox");
    viewBox.style.display = 'block';

    //失去颌面观焦点
    modelGltf.children[0].position.set(0, 0, 0);
    modelGltf.children[0].rotation.x = 0;
    modelGltf.children[0].rotation.y = 0;
    modelGltf.children[0].rotation.z = 0;

    modelGltf.children[1].position.set(0, 0, 0);
    modelGltf.children[1].rotation.x = 0;
    modelGltf.children[1].rotation.y = 0;
    modelGltf.children[1].rotation.z = 0;
    dbJawMenuStatu = false;          
};

//添加菜单焦点样式
function updateMenuStyle(menuLabelId){
    let odiv= document.getElementById(menuLabelId);
      if(odiv.classList.contains('slt')){
          odiv.classList.remove("slt");
      }else{
        odiv.classList.add("slt");
      }
      removeMenuStyle(menuLabelId);
};
function removeMenuStyle(menuLabelId){
    let menuLabelIds = ["attachButton", "contrastButton", "occlusionButton", "dbJawButton"];
    menuLabelIds = menuLabelIds.filter(function(item) {
        return item !== menuLabelId
      });

    for(var i = 0; i < menuLabelIds.length; i++) {
        document.getElementById(menuLabelIds[i]).classList.remove("slt");
    }
}

//======================内容体中点击按钮事件=============================
//上下牙都显示
function showAll() {
    modelGltf.children[0].visible = true;
    modelGltf.children[1].visible = true;

    //判断附件是否获取焦点
    // let odiv= document.getElementById("attachButton");
    //   if(odiv.classList.contains('slt')){
    //     attachGotFocus();
    //   }else{
    //     attachLoseFocus();
    //   }
}
//旋转
function spin(selectSpin) {
    //重置模型的相机位置和角度
    controls.reset();
    // console.log('顶点位置数据', modelStl.children[0].children[0].geometry.attributes.position);  
    upToothStatu = false;
    lowerToothStatu = false;
    if (currentSpin == 'modelFont') {
        switch (selectSpin) {
            case 'modelBack':
                modelGltf.children[1].rotateY(Math.PI);
                modelGltf.children[0].rotateY(Math.PI); 
                updateViewStyle("backLi");
                break;
            case 'modelLeft':
                modelGltf.children[1].rotateY(Math.PI / 2);
                modelGltf.children[0].rotateY(Math.PI / 2);
                updateViewStyle("leftLi");
                break;
            case 'modelRight':
                modelGltf.children[1].rotateY(-Math.PI / 2);
                modelGltf.children[0].rotateY(-Math.PI / 2);
                updateViewStyle("rightLi");
                break;
            case 'modelFont':
                updateViewStyle("frontLi");
                break;    
        }
        
    } else if (currentSpin == 'modelLeft') {
        switch (selectSpin) {
            case 'modelBack':
                modelGltf.children[1].rotateY(Math.PI / 2);
                modelGltf.children[0].rotateY(Math.PI / 2);
                updateViewStyle("backLi");
                break;
            case 'modelRight':
                modelGltf.children[1].rotateY(Math.PI);
                modelGltf.children[0].rotateY(Math.PI);
                updateViewStyle("rightLi");
                break;
            case 'modelFont':
                modelGltf.children[1].rotateY(-Math.PI / 2);
                modelGltf.children[0].rotateY(-Math.PI / 2);
                updateViewStyle("frontLi");
                break;
            case 'modelLeft':
                updateViewStyle("leftLi");
                break;    
        }
    } else if (currentSpin == 'modelBack') {
        switch (selectSpin) {
            case 'modelRight':
                modelGltf.children[1].rotateY(Math.PI / 2);
                modelGltf.children[0].rotateY(Math.PI / 2);
                updateViewStyle("rightLi");
                break;
            case 'modelFont':
                modelGltf.children[1].rotateY(Math.PI);
                modelGltf.children[0].rotateY(Math.PI);
                updateViewStyle("frontLi");
                break;
            case 'modelLeft':
                modelGltf.children[1].rotateY(-Math.PI / 2);
                modelGltf.children[0].rotateY(-Math.PI / 2);
                updateViewStyle("leftLi");
                break;
            case 'modelBack':
                updateViewStyle("backLi");
                break;    
        }
    } else if (currentSpin == 'modelRight') {
        switch (selectSpin) {
            case 'modelBack':
                modelGltf.children[1].rotateY(-Math.PI / 2);
                modelGltf.children[0].rotateY(-Math.PI / 2);
                updateViewStyle("backLi");
                break;
            case 'modelFont':
                modelGltf.children[1].rotateY(Math.PI / 2);
                modelGltf.children[0].rotateY(Math.PI / 2);
                updateViewStyle("frontLi");
                break;
            case 'modelLeft':
                modelGltf.children[1].rotateY(Math.PI);
                modelGltf.children[0].rotateY(Math.PI);
                updateViewStyle("leftLi");
                break;
            case 'modelRight':
                updateViewStyle("rightLi");
                break;    
        }
    }
    //scene.add(modelGltf);
}
//点击上颌
const upToothClick = ()=>{
    showAll();
    if (!upToothStatu) {
        modelGltf.children[1].visible = false;//控制上牙龈是否显示
        //.visible = false;
        upToothStatu = true;

        updateViewStyle("upperLi");
    } else {
        upToothStatu = false;
        recoverSpinFocus();
    }
    
}

//点击下颌
const lowerToothClick = ()=>{
    showAll();
    if (!lowerToothStatu) {
        modelGltf.children[0].visible = false;
        //.visible = false;
        lowerToothStatu = true;

        updateViewStyle("lowerLi");
    } else {
        lowerToothStatu = false;
        recoverSpinFocus();        
    }    
}

//根据当前扭转的情况，设置对应的焦点
function recoverSpinFocus(){
    if (currentSpin == 'modelFont') {
        updateViewStyle("frontLi");
    }else if (currentSpin == 'modelLeft') {
        updateViewStyle("leftLi");
    }else if (currentSpin == 'modelBack') {
        updateViewStyle("backLi");
    }else if (currentSpin == 'modelRight') {
        updateViewStyle("rightLi");
    }
}

const spinToothClick = (_this)=>{
    showAll();
    spin(_this);
    currentSpin = _this;
}

//添加页体视图焦点样式
function updateViewStyle(viewLiId){
    let odiv= document.getElementById(viewLiId);
      if(odiv.classList.contains('angleTrue')){
          odiv.classList.remove("angleTrue");
      }else{
        odiv.classList.add("angleTrue");
      }
      removeViewStyle(viewLiId);
};
function removeViewStyle(viewLiId){
    let viewLiIds = ["upperLi", "rightLi", "frontLi", "backLi","leftLi","lowerLi"];
    viewLiIds = viewLiIds.filter(function(item) {
        return item !== viewLiId
      });

    for(var i = 0; i < viewLiIds.length; i++) {
        document.getElementById(viewLiIds[i]).classList.remove("angleTrue");
    }
}


//到处渲染器，让vue引用
export {renderer};
export {attachmentsMenu,occlusMenu,dbJawMenu,contrastMenu};
export {upToothClick,lowerToothClick,spinToothClick};



// WEBPACK FOOTER //
// ./src/business/index.js